import React, {useEffect} from 'react'
import { Box } from '@mui/system'
import Sidebar from './sidebar'
import {  Button, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';
import CustomToolbar from './CustomToolbarPrint';
import { useNavigate, useSearchParams } from 'react-router-dom';


import { collection, query, getDocs } from "firebase/firestore"; 
import {db} from "../firebase.js";

import { genderProject } from '../utils/reportUtils'

import "../App.css"


function SearchHeader ({setFilter, backupData, projectFilter, onProjectChange}){

    const [firstNameSearch, setFirstNameSearch] = React.useState("");
    const [surnameSearch, setSurnameSearch] = React.useState("");
    const [contactSearch, setContactSearch] = React.useState("");
    const [dobSearch, setDobSearch] = React.useState("");

    const filterRows = (project, searches) => {
      const { firstName = "", surname = "", contact = "", dob = "" } = searches;
      return backupData.filter(function (el) {
        const projectMatch = project === "all" || genderProject(el.gender).toLowerCase() === project;
        const firstNameMatch = !firstName || (el.firstName && el.firstName.toLowerCase().includes(firstName.toLowerCase()));
        const surnameMatch = !surname || (el.surName && el.surName.toLowerCase().includes(surname.toLowerCase()));
        const contactMatch = !contact || (el.contact && el.contact.toLowerCase().includes(contact.toLowerCase()));
        const dobMatch = !dob || (el.DOB && el.DOB.toLowerCase().includes(dob.toLowerCase()));

        return projectMatch && firstNameMatch && surnameMatch && contactMatch && dobMatch;
      });
    };

   React.useEffect(() => {
      setFilter(filterRows(projectFilter, {
        firstName: firstNameSearch,
        surname: surnameSearch,
        contact: contactSearch,
        dob: dobSearch,
      }));
   }, [backupData, projectFilter]);

    let filterResults = () => {
        setFilter(filterRows(projectFilter, {
          firstName: firstNameSearch,
          surname: surnameSearch,
          contact: contactSearch,
          dob: dobSearch,
        }));
      }


  return (
    <div className="Head-Search">
            <FormControl size="small" style={{ width: "220px", backgroundColor: "white" }}>
              <InputLabel id="project-filter-label">Project</InputLabel>
              <Select
                labelId="project-filter-label"
                label="Project"
                value={projectFilter}
                onChange={(e) => onProjectChange(e.target.value)}
              >
                <MenuItem value="all">Both Projects</MenuItem>
                <MenuItem value="moses">Moses Project</MenuItem>
                <MenuItem value="miriam">Miriam Project</MenuItem>
              </Select>
            </FormControl>
            <div style={{ width: "70vw", display: "flex", gap: "10px" }}>
              <TextField
                style={{ width: "300px" }}
                label="Search by First Name"
                variant="outlined"
                value={firstNameSearch}
                onChange={(e) => setFirstNameSearch(e.target.value)}
              />
              <TextField
                style={{ width: "300px" }}
                label="Search by Surname"
                variant="outlined"
                value={surnameSearch}
                onChange={(e) => setSurnameSearch(e.target.value)}
              />
              <TextField
                style={{ width: "300px" }}
                label="Search by Contact Number"
                variant="outlined"
                value={contactSearch}
                onChange={(e) => setContactSearch(e.target.value)}
              />
              <TextField
                style={{ width: "300px" }}
                label="Search by DOB"
                variant="outlined"
                value={dobSearch}
                onChange={(e) => setDobSearch(e.target.value)}
              />
              <Button onClick={filterResults}> Search </Button>
              <Button onClick={()=>{
                setFirstNameSearch("");
                setSurnameSearch("");
                setContactSearch("");
                setDobSearch("");
                setFilter(filterRows(projectFilter, {}));
              }}> Reset </Button>
            </div>
          </div>
  )

}


export default function ViewAll() {
    const [rows, setRows] = React.useState([])
    const [backupRow, setBackupRows] = React.useState([]);

    const [searchParams, setSearchParams] = useSearchParams();
    const projectParam = searchParams.get("project");
    const projectFilter = projectParam === "moses" || projectParam === "miriam" ? projectParam : "all";

    const handleProjectChange = (value) => {
      setSearchParams(value === "all" ? {} : { project: value });
    };

    let arr = [];
  
    useEffect( () => {
      test()
  
      async function test(){
        arr=[]
        getData()
      }
  
      setRows(arr)
      setBackupRows(arr);
  
  }, []);
  
  async function getData (){
    let arr = []
    const q = query(collection(db, "employee"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      let obj = doc.data();
      Object.assign(obj, {doc: doc.id});
      arr.push(obj)
     });  

     arr.sort((a, b) => {
      return (a.surName || "").localeCompare(b.surName || "");
    });
  
     setRows(arr)
     setBackupRows(arr);
  
  }
  
  
  
    const navigate = useNavigate();
    const columns = [
      //{ field: 'id', headerName: 'ID', width: 70 },
      { field: 'firstName', headerName: 'Name', width: 150 },
      { field: 'surName', headerName: 'Surname', width: 150 },
      //{ field: 'lastName', headerName: 'Last Name', width: 150 },
      // {
      //   field: 'age',
      //   headerName: 'Age',
      //   type: 'number',
      // },
      {
          field: 'startDate',
          headerName: 'Start Date',
          // type: 'number',
          width: 170 
          
        },
        { field: 'postCode', headerName: 'Post Code' , width: 150 },
        { field: 'DOB', headerName: 'Date of Birth' , width: 150 },
        { field: 'referralForm', headerName: 'Referral From' , width: 150 },
        {
          field: 'housingStatus',
          headerName: 'Status',
          width: 150,
          valueGetter: (params) => {
            const house = params.row.house || [];
            const last = [...house].reverse().find((h) => h && h.status);
            return last ? last.status : '';
          },
        },
        {
          field: 'housingLocation',
          headerName: 'Location',
          width: 150,
          valueGetter: (params) => {
            const house = params.row.house || [];
            const last = [...house].reverse().find((h) => h && h.location);
            return last ? last.location : '';
          },
        },
        { field: 'probation', headerName: 'Probation' , width: 150 },
        // {
        //   field: "action",
        //   headerName: "",
        //   sortable: false,
        //   renderCell: (params) => {
        //     const onClick = (e) => {
             
              
        //       navigate("/profile");
        //     };
      
        //     return <Button onClick={onClick} style={{color: "#1c3261"}}>View Details</Button>;
        //   }
        // },
        
    
      
    ];
  
    const handleRowClick = (params) => {
      //console.log(params.row);
      navigate("/profile",{
        state: {
          employee: params.row,
          activeStep: 0,
        }
      });
    };
    
    return (
  
        
  
        <Box sx={{ display: 'flex' }}>
          <Sidebar />
       
         
          <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{marginTop: "50px", justifyContent: "center", alignItems: "center"}}>
         
          <div style={{ height: 640, width: '100%'}}>

          <SearchHeader
            backupData={backupRow}
            setFilter={(e) => setRows(e)}
            projectFilter={projectFilter}
            onProjectChange={handleProjectChange}
          />
              <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={10}
                  rowsPerPageOptions={[5]}
                  //checkboxSelection
                  onRowDoubleClick={handleRowClick}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
              />
          </div>
          
        </Box>
       
          
      </Box>
  
      
    )
}
